import { ISchemaObject, ISignal } from '@augloop/types-core';
import { IMessageBase, Person } from './smart-compose-chat-base';

/**
 * Signal for smart compose suggestions in chat.
 */
export interface IConversationContext extends ISchemaObject {
    /**
     * Name of conversation
     */
    readonly n?: string;

    /**
     * Thread id.
     */
    readonly t?: string;

    /**
     * Participat list.
     */
    readonly p?: Person[];

    /**
     * Current user.
     */
    readonly u?: Person;

    /**
     * Client type
     */
    readonly c?: ClientType;

    /**
     * Version
     */
    readonly v?: number;
}

export interface IMessage extends IMessageBase {

}

export enum ClientType {
    Desktop,
    Android,
    iOS
}

/**
 * Signal for smart compose telemetry information.
 */
export interface ISCTelemetry extends ISignal {
    /**
     * Smart Compose suggestions Rendered in the last 30s
     */
    readonly sr?: number;

    /**
     * Smart Compose suggestions accepted in the last 30s
     */
    readonly sa?: number;

    /**
     * Smart Compose suggestions typed through in the last 30s
     */
    readonly st?: number;

    /**
     * Render latency list.
     */
    readonly l?: number[];
}
